import { Fragment } from "react";
import { cn } from "@/lib/utils";
import { getTextParts } from "@/components/storyboard/quiz/utils/quizUtils";
import { alignClozeGapsWithQuestion } from "@/components/storyboard/quiz/review/buildReviewItem";

interface ReviewGap {
  userAnswer: string;
  correctAnswer: string;
  correct: boolean;
}

interface QuizReviewClozeProps {
  clozeText: string;
  gapMark: string;
  gaps: ReviewGap[];
  isCorrect: boolean;
}

/**
 * Cloze sentence recap with per-gap marks — used on the completed-quiz card.
 */
const QuizReviewCloze = ({
  clozeText,
  gapMark,
  gaps,
  isCorrect,
}: QuizReviewClozeProps) => {
  const textParts = getTextParts(clozeText, gapMark);
  const displayGaps = alignClozeGapsWithQuestion(gaps, isCorrect);

  return (
    <div className="min-w-0 w-full leading-loose text-primary">
      {textParts.map((part, index) => {
        const gap = displayGaps[index];
        return (
          <Fragment key={index}>
            {part}
            {index < textParts.length - 1 && gap && (
              <span
                className={cn(
                  "mx-1 inline-flex items-center rounded-md border-2 px-2 py-0.5 align-baseline font-semibold",
                  gap.correct
                    ? "border-success bg-success-light text-success-foreground"
                    : "border-error bg-error-light text-error-foreground"
                )}
              >
                {gap.userAnswer || "—"}
              </span>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default QuizReviewCloze;
